module.exports = __webpack_public_path__ + "img/pencil-alt-grey.b13834d5.svg";